// removed by extract-text-webpack-plugin
module.exports = {"imageArea":"_2ecRxMwsqIWqAwsNHu3zLz","is-on-screen":"_3DVTt5Gb8mUj7GfImc4QND","image":"_2d_5OM5OAt8Soe6VLQ-V2q","block":"_1wefyJ2MB9Pp0VD5UrwFYW","inList":"_2Vd23THPSt0-_ik1GFojOb","textContent":"_3CboN7KZyV0Xi_U5OjJzMu","projectHeading":"_3RAp1M3gF15AnYPOSi5pIa","text":"_1XekCs8Nn8ALq-I6UEzK_S","button":"_1L8cewDu1-LzfYpgS4kmFK","icon":"CDDvfrXW_n3uNLUr-LvEs","darkgray":"_3NUf-pyVuA19PfJe_MXPI0","inner":"Hwzm3B-IQw6yOhLY_ppyb","imageWrapper":"_2FPEv9RBu58FZxIUuyvceV"};


//////////////////
// WEBPACK FOOTER
// ./src/components/HighlightedProjectBlock/HighlightedProjectBlock.module.scss
// module id = 776
// module chunks = 0